import { FaSort, FaDownload } from 'react-icons/fa';
import React, { useEffect, useState } from 'react';
import { handleError } from '../utils/errorHandler';
import { colorsRangeHex, formatNumber, divipolas } from '../Transversal';
import { DEFAULT_FILTER, ArcFiltros } from './SesionApp';
import { API_URL, HEIGHT_BODY, WIDTH_RIGHT_PANEL, COLOR_FONT_TITLE, esCelular, topFooterOnExpanded, widthCelular } from '../Config';
import { apiFetch } from '../apiClient';

let filterAnio = "";
let filterTipoClasificador = "";
let filterCodigoDivipolaPdetRegion = "";
let filterCodigoDivipolaPdetMunicipio = "";
let filterCodigoDivipolaDpto = "";
let filterCodigoDivipolaMpio = "";
let filterSector = "";
let filterEntidad = "";
let filterEsPDET = "";
let cargado = false;
let listaCantidades: number[] = [];
let currentOrder = "asc";
let consecutivoReact = 0;

class DivipolaCantidad {
    public codigoDivipola: string = "";
    public nombre: string = "";
    public cantidad: number = 0;
    public cantidadGlobal: number = 0;
}

interface BarraProps {
    filtrar: string;
    codigoDivipola: string;
    setCodigoDivipola: (codigo: string) => void;
}

const Barras: React.FC<BarraProps> = ({ filtrar, codigoDivipola, setCodigoDivipola }) => {

    const [divipolaCantidad, setdivipolaCantidad] = useState<DivipolaCantidad[]>([]);
    const [cantidadNacional, setCantidadNacional] = useState<number>(0);

    const getCantidadEncabezado = (datos: DivipolaCantidad[]) => {
        let cantidad = Math.max(...datos.map(divipola => divipola.cantidadGlobal));
        if (filterCodigoDivipolaDpto !== "") {
            const cantidadDpto = datos.find(divipola => divipola.codigoDivipola === filterCodigoDivipolaDpto);
            if (cantidadDpto) {
                if (DEFAULT_FILTER.sentenciaT302 === "1") {
                    cantidad = cantidadDpto.cantidad;
                }
                else {
                    cantidad = cantidadDpto.cantidadGlobal;
                }
            }
        }
        if (filterCodigoDivipolaMpio !== "") {
            const cantidadMpio = datos.find(divipola => divipola.codigoDivipola === filterCodigoDivipolaMpio);
            if (cantidadMpio) {
                cantidad = cantidadMpio.cantidad;
            }
        }
        return cantidad;
    }

    const fetchDatos = async () => {
        var url = "";
        try {
            const startTime = performance.now();
            const queryString = Object.keys(DEFAULT_FILTER)
                .filter(key => DEFAULT_FILTER[key as keyof ArcFiltros] !== undefined)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(DEFAULT_FILTER[key as keyof ArcFiltros] ?? '')}`)
                .join('&');
            url = `${API_URL}/ArcIndicador/GetDivipolaCantidades?${queryString}`
            const response = await apiFetch(url);
            const data = await response.json();
            cargado = true;
            setdivipolaCantidad(data);
            const endTime = performance.now();
            const duration = endTime - startTime;
            console.log(`Barras Fetch duration: ${duration} ms`);
        } catch (error) {
            handleError(error);
        }
    };

    const clickOnDivipola = (codigoDivipola: string) => {
        const divipola = divipolaCantidad.find(divipola => Number(divipola.codigoDivipola) === Number(codigoDivipola));
        if (divipola) {
            if (DEFAULT_FILTER.esPDET == "1") {
                if (DEFAULT_FILTER.codigoDivipolaPdetRegion == "") {
                    DEFAULT_FILTER.codigoDivipolaPdetRegion = divipola.codigoDivipola;
                    consecutivoReact++;
                    setCodigoDivipola(consecutivoReact.toString());
                }
                else {
                    if (DEFAULT_FILTER.codigoDivipolaDpto == "") {
                        DEFAULT_FILTER.codigoDivipolaDpto = divipola.codigoDivipola;
                        consecutivoReact++;
                        setCodigoDivipola(consecutivoReact.toString());
                    }
                    else {
                        //if (DEFAULT_FILTER.codigoDivipolaPdetMunicipio == "") {
                        DEFAULT_FILTER.codigoDivipolaMpio = divipola.codigoDivipola;
                        DEFAULT_FILTER.codigoDivipolaPdetMunicipio = divipola.codigoDivipola;
                        consecutivoReact++;
                        setCodigoDivipola(consecutivoReact.toString());
                        //}
                    }
                }
            }
            else {
                if (DEFAULT_FILTER.codigoDivipolaDpto == "") {
                    DEFAULT_FILTER.codigoDivipolaDpto = divipola.codigoDivipola;
                    consecutivoReact++;
                    setCodigoDivipola(consecutivoReact.toString());
                }
                else {
                    //if (DEFAULT_FILTER.codigoDivipolaMpio == "") {
                    DEFAULT_FILTER.codigoDivipolaMpio = divipola.codigoDivipola;
                    consecutivoReact++;
                    setCodigoDivipola(consecutivoReact.toString());
                    //}
                }
            }
            getDatos();
        }
    }

    let yPostScroll = 0;
    const updateRenderer = () => {
        const barrasDiv = document.getElementById('barrasDiv');
        if (divipolaCantidad.length == 0) {
            setCantidadNacional(0);
            if (barrasDiv) {
                barrasDiv.innerHTML = '';
                // innerHTML is only used with trusted/generated content, not user input (safe from XSS)
            }
            return;
        };
        const cantidadNacionalNuevo = getCantidadEncabezado(divipolaCantidad);
        setCantidadNacional(cantidadNacionalNuevo);
        listaCantidades = divipolaCantidad.filter((divipola) => {
            if (filterCodigoDivipolaDpto !== "") {
                return divipola.codigoDivipola.length === 5;
            }
            return true;
        }).filter((divipola) => divipola.codigoDivipola != 'TOTAL' && divipola.codigoDivipola != 'DESAGREGACIÓN').map((divipola) => divipola.cantidad);
        let cantidadNacionalVer = getCantidadEncabezado(divipolaCantidad);
        setCantidadNacional(cantidadNacionalVer);

        let index = 0;
        if (barrasDiv) {
            barrasDiv.innerHTML = '';
            // innerHTML is only used with trusted/generated content, not user input (safe from XSS)
            divipolaCantidad
                .filter((divipola) => divipola.codigoDivipola != 'TOTAL' && divipola.codigoDivipola != 'DESAGREGACIÓN')
                .filter((divipola) => divipola.cantidad > 0)
                .filter((divipola) => {
                    if (filterCodigoDivipolaDpto !== "") {
                        return divipola.codigoDivipola.length === 5;
                    }
                    return true;
                })
                .forEach((divipola) => {
                    index++;
                    const row = document.createElement('div');
                    row.style.display = 'flex';
                    row.style.alignItems = 'center';
                    row.style.marginBottom = '0px';
                    row.style.fontSize = '10px';
                    row.style.cursor = 'pointer'; // Add this line to change cursor to hand pointer
                    row.onclick = () => clickOnDivipola(divipola.codigoDivipola);

                    const nombredivipola = document.createElement('div');
                    nombredivipola.style.flex = '0 0 100px';
                    nombredivipola.style.height = '20px';
                    nombredivipola.style.overflow = 'hidden';
                    nombredivipola.style.whiteSpace = 'nowrap';
                    nombredivipola.style.textOverflow = 'ellipsis';
                    nombredivipola.textContent = divipola.nombre;

                    if (divipola.codigoDivipola === filterCodigoDivipolaMpio) {
                        yPostScroll = index
                        nombredivipola.style.backgroundColor = 'yellow';
                        nombredivipola.style.fontWeight = 'bold';
                    }
                    var anchoBarra = "150px";
                    if (esCelular) {
                        anchoBarra = "100px";
                    }
                    const barraContainer = document.createElement('div');
                    barraContainer.style.flex = '0 0 ' + anchoBarra;
                    barraContainer.style.height = '15px';
                    barraContainer.style.backgroundColor = '#e0e0e0';
                    barraContainer.style.margin = '0 10px';
                    barraContainer.style.position = 'relative';

                    const lineaNacional = document.createElement('div');
                    lineaNacional.style.position = 'absolute';
                    lineaNacional.style.left = `${(divipola.cantidad / cantidadNacionalVer) * 100}%`;
                    lineaNacional.style.width = '2px';
                    lineaNacional.style.height = '100%';
                    lineaNacional.style.backgroundColor = 'gray';

                    barraContainer.appendChild(lineaNacional);

                    const barra = document.createElement('div');
                    barra.style.height = '100%';
                    barra.style.width = anchoBarra;
                    barra.style.backgroundColor = colorsRangeHex(listaCantidades, divipola.cantidad, divipola.codigoDivipola);
                    barra.style.borderRadius = '5px';

                    const porcentaje = document.createElement('div');
                    porcentaje.style.flex = '0 0 60px';
                    porcentaje.style.textAlign = 'right';
                    //porcentaje.textContent = `${formatNumber((divipola.cantidad / Math.max(...listaCantidades)) * 100)}%`;
                    porcentaje.textContent = `${formatNumber((divipola.cantidad / cantidadNacionalVer) * 100)}%`;

                    barraContainer.appendChild(barra);
                    row.appendChild(nombredivipola);
                    row.appendChild(barraContainer);
                    row.appendChild(porcentaje);
                    barrasDiv.appendChild(row);
                });
        }
        //after render, scroll to selected row
        if (barrasDiv) {
            barrasDiv.scrollTop = (yPostScroll - 1) * 20;
        }
    };

    const getDatos = async () => {
        console.log(DEFAULT_FILTER);
        if (DEFAULT_FILTER.anio != filterAnio
            || DEFAULT_FILTER.tipoClasificador != filterTipoClasificador
            || filterCodigoDivipolaPdetRegion != DEFAULT_FILTER.codigoDivipolaPdetRegion
            || filterCodigoDivipolaPdetMunicipio != DEFAULT_FILTER.codigoDivipolaPdetMunicipio
            || DEFAULT_FILTER.codigoDivipolaDpto != filterCodigoDivipolaDpto
            || DEFAULT_FILTER.codigoDivipolaMpio != filterCodigoDivipolaMpio
            || DEFAULT_FILTER.sector != filterSector
            || DEFAULT_FILTER.entidad != filterEntidad
            || DEFAULT_FILTER.esPDET != filterEsPDET
        ) {
            filterAnio = DEFAULT_FILTER.anio;
            filterTipoClasificador = DEFAULT_FILTER.tipoClasificador;
            filterCodigoDivipolaPdetRegion = DEFAULT_FILTER.codigoDivipolaPdetRegion;
            filterCodigoDivipolaPdetMunicipio = DEFAULT_FILTER.codigoDivipolaPdetMunicipio;
            filterCodigoDivipolaDpto = DEFAULT_FILTER.codigoDivipolaDpto;
            filterCodigoDivipolaMpio = DEFAULT_FILTER.codigoDivipolaMpio;
            filterSector = DEFAULT_FILTER.sector;
            filterEntidad = DEFAULT_FILTER.entidad;
            filterEsPDET = DEFAULT_FILTER.esPDET;
            fetchDatos();
        }
        updateRenderer();
    }

    const changeOrder = () => {
        if (currentOrder === "asc") {
            currentOrder = "desc";
            divipolaCantidad.sort((a, b) => a.cantidad - b.cantidad);
        } else {
            currentOrder = "asc";
            divipolaCantidad.sort((a, b) => b.cantidad - a.cantidad);
        }
        updateRenderer();
    }


    const renderButtons = () => {
        return (
            <div style={{ height: 20, margin: '5px', display: 'flex', justifyContent: 'space-between' }}>
                <button style={{ border: 'none', background: 'none', cursor: 'pointer' }} onClick={() => {
                    changeOrder();
                }}>
                    <FaSort color={COLOR_FONT_TITLE} />
                </button>
                <button style={{ border: 'none', background: 'none', cursor: 'pointer' }} onClick={() => {
                    downloadExcel();
                }}>
                    <FaDownload color={COLOR_FONT_TITLE} />
                </button>
            </div>
        );
    };
    const downloadExcel = () => {
        const XLSX = require('xlsx');
        const filteredGrilla = divipolaCantidad.map(({ codigoDivipola, nombre, cantidad, cantidadGlobal }) => ({
            "Código Divipola": codigoDivipola,
            "Departamento/Municipio": nombre,
            "Cantidad": cantidad,
            "Cantidad Global": cantidadGlobal
        }));
        const worksheet = XLSX.utils.json_to_sheet(filteredGrilla);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'DivipolaCantidad');
        const filtrosSeleccionados = Object.keys(DEFAULT_FILTER)
            .filter(key => {
                const value = DEFAULT_FILTER[key as keyof ArcFiltros];
                return value !== "" && (typeof value !== 'number' || value > 0);
            })
            .map(key => `${key}-${DEFAULT_FILTER[key as keyof ArcFiltros]}`)
            .join('_');
        const nombreArchivo = `barras_${DEFAULT_FILTER.anio}_${filtrosSeleccionados}.xlsx`;
        XLSX.writeFile(workbook, nombreArchivo);
    };

    useEffect(() => {
        getDatos();
    }, [filtrar, codigoDivipola, divipolaCantidad]);

    let selectedNombre = 'Nacional';
    if (filterCodigoDivipolaDpto !== "") {
        const divipola = divipolas.find(divipola => divipola.Tipo == "Departamento" && divipola.CodigoDivipola == filterCodigoDivipolaDpto);
        selectedNombre = divipola ? divipola.Nombre : 'Nacional';
    }
    if (filterCodigoDivipolaMpio !== "") {
        const divipola = divipolas.find(divipola => divipola.Tipo == "Municipio" && divipola.CodigoDivipola == filterCodigoDivipolaMpio);
        selectedNombre = divipola ? divipola.Nombre : 'Municipio';
    }
    if (filterCodigoDivipolaPdetRegion !== "") {
        const divipola = divipolas.find(divipola => divipola.Tipo == "PdetRegion" && divipola.CodigoDivipola == filterCodigoDivipolaPdetRegion);
        selectedNombre = divipola ? divipola.Nombre : 'Pdet';
        if (filterCodigoDivipolaDpto !== "") {
            const divipola = divipolas.find(divipola => divipola.Tipo == "Departamento" && divipola.CodigoDivipola == filterCodigoDivipolaDpto);
            selectedNombre = divipola ? divipola.Nombre : 'Nacional';
        }
    }


    useEffect(() => {
        getDatos();
    }, []);

    useEffect(() => {
        updateRenderer();
    }, [divipolaCantidad]);
    if (divipolaCantidad.length == 0 && cargado) {
        return (
            <div style={{ height: HEIGHT_BODY, width: '100%', display: 'grid', placeItems: 'center', textAlign: 'center' }}>
                No hay indicadores con los criterios seleccionados
            </div>
        );
    }
    return (
        <div style={{ height: HEIGHT_BODY }}>
            <div id="cantidadNacionalDiv" style={{ marginBottom: '10px', textAlign: 'center', fontSize: '12px' }}>
                <div style={{ color: "#36c", fontWeight: 'bold' }}>Acciones territoriales monitoreadas</div>
                <b>{selectedNombre}</b> ({formatNumber(cantidadNacional)})
                <div style={{ marginBottom: '10px', textAlign: 'center', fontSize: '10px' }}>Corresponde al porcentaje de concentración de intervenciones territoriales de los indicadores con desagregaciones</div>
            </div>
            <div style={{ height: 30, }}>
                {renderButtons()}
            </div>
            <div id="barrasDiv" style={{ width: WIDTH_RIGHT_PANEL, height: "700px", overflowY: 'visible', overflowX: 'hidden', paddingLeft: '10px', paddingRight: '20px', scrollbarWidth: 'thin', justifyContent: 'center', alignItems: 'center' }}>
                <br /><br />
                Cargando...
            </div>
        </div>
    );
};


export default Barras;